<template>
  <div>
    <Breadcrumb></Breadcrumb>
    <div class="common-limit line-height-40">
      <div class="form-body">
        <el-form ref="form" :model="queryParams" label-width="80px">
          <el-row :gutter="24">
            <el-col :span="8">
              <el-form-item label="店铺名称：" prop="shopName">
                <el-input
                  size="small"
                  v-model="queryParams.shopName"
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="启用状态：" prop="shopStatus">
                <el-select
                  style="width: 100%"
                  size="small"
                  v-model="queryParams.shopStatus"
                  clearable
                >
                  <template v-for="(value, key) in dictData['shop_status']">
                    <el-option
                      :key="value.value"
                      :label="value.label"
                      :value="value.value"
                    ></el-option>
                  </template>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="授权状态：" prop="authStatus">
                <el-select
                  style="width: 100%"
                  size="small"
                  v-model="queryParams.authStatus"
                  clearable
                >
                  <template v-for="(value, key) in dictData['auth_status']">
                    <el-option
                      :key="value.value"
                      :label="value.label"
                      :value="value.value"
                    ></el-option>
                  </template>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="8">
              <el-form-item label="添加时间：" prop="time">
                <el-date-picker
                  style="width: 100%"
                  size="small"
                  v-model="queryParams.time"
                  type="daterange"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  :picker-options="pickerOptions"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="16" class="btn-bar-right">
              <el-button type="primary" size="small" @click="loadData"
                >搜索</el-button
              >
              <el-button size="small" @click="resetForm">重置</el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>

    <div class="form-body">
      <span style="float: left">
        <el-button type="primary" size="small" @click="handleShowEditShop({})"
          >新增店铺</el-button
        >
      </span>
      <span
        style="float: left;font-size:14px;margin: 0 0 0 16px;line-height: 45px;"
      >
        <a
          target="_blank"
          href="https://ec-shopmall-cn.oss-cn-hangzhou.aliyuncs.com/downloads/template/Address.docx"
          style="color:red;text-decoration:underline "
          >仓库设置说明</a
        >
      </span>
      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="queryParams.pageNum"
        :limit.sync="queryParams.pageSize"
        @pagination="loadData"
        :layout="'slot, total, sizes, prev, pager, next, jumper'"
      >
      </pagination>
      <el-table :data="tableData">
        <el-table-column label="添加时间" prop="createTime"></el-table-column>
        <el-table-column label="店铺名称" prop="shopName">
          <template slot-scope="scope">
            {{ scope.row.shopName }}
          </template>
        </el-table-column>
        <el-table-column label="关联账号" prop="operNos">
          <template slot-scope="scope">
            <el-button
              type="text"
              @click="handleShowRelaSubAccount(scope.row)"
              >{{
                scope.row.operNos == ""
                  ? "0"
                  : scope.row.operNos.split(",").length
              }}</el-button
            >
            <i
              v-if="false"
              @click="handleShowRelaSubAccount(scope.row)"
              class="el-icon-edit-outline blue"
              style="margin: 0 0 0 8px; color: #4934b2"
            ></i>
          </template>
        </el-table-column>
        <el-table-column label="自动同步订单" prop="shopStatus">
          <template slot-scope="scope">
            <span> {{ scope.row.isSync == "1" ? "是" : "否" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="授权状态" prop="shopStatus">
          <template slot-scope="scope">
            <div
              style="color:red;"
              v-if="scope.row.isExpire && scope.row.authStatus == '02'"
            >
              已过期
            </div>
            <div
              :style="{
                color: scope.row.authStatus == '02' ? '#00b78d' : 'inherit',
              }"
              v-else
            >
              {{ dictMap["auth_status"][scope.row.authStatus] }}
            </div>
            <div>{{ scope.row.authTime }}</div>
          </template>
        </el-table-column>
        <el-table-column label="启用状态" prop="shopStatus">
          <template slot-scope="scope">
            <span>{{ dictMap["shop_status"][scope.row.shopStatus] }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" prop="oper" fixed="right" width="250">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="mini"
              @click="handleShowRelaSubAccount(scope.row)"
              >关联账号</el-button
            >
            <el-button
              v-if="platNo != '11'"
              type="text"
              size="mini"
              @click="handleShowEditShop(scope.row)"
              >编辑</el-button
            >
            <el-button
              v-if="scope.row.authStatus == '01'"
              type="text"
              size="mini"
              @click="handleAuth(scope.row)"
              >授权</el-button
            >
            <el-button type="text" size="mini" @click="handleAuth(scope.row)"
              >重新授权</el-button
            >
            <el-button
              type="text"
              size="mini"
              @click="giveShopAuth(scope.row.shopId, '01')"
              v-if="scope.row.shopStatus != '01'"
              >启用</el-button
            >

            <el-button
              type="text"
              size="mini"
              @click="giveShopAuth(scope.row.shopId, '02')"
              v-else
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <pagination
        class="bottom-sticky"
        v-show="total > 0"
        :total="total"
        :page.sync="queryParams.pageNum"
        :limit.sync="queryParams.pageSize"
        @pagination="loadData"
      />
    </div>

    <el-dialog
      :close-on-click-modal="false"
      title="查看"
      :visible.sync="dialogVisible"
    >
      <div>
        <el-form ref="form" :model="detailForm" label-width="140px">
          <el-form-item label="店铺名称：">
            {{ detailForm.shopName }}
          </el-form-item>
          <el-form-item label="开户站：">
            {{ dictMap["amazon_site"][detailForm.amazonSite] }}
          </el-form-item>
          <el-form-item label="Amazon账号：">
            {{ detailForm.amazonAccount }}
          </el-form-item>
          <el-form-item label="卖家编号：">
            {{ detailForm.merchantId }}
          </el-form-item>
          <el-form-item label="MWS授权令牌：">
            {{ detailForm.MWS }}
          </el-form-item>
          <el-form-item label="自动同步订单："
            >{{ detailForm.isSync }}
          </el-form-item>
          <el-form-item label="授权时间：">
            {{ detailForm.authTime }}</el-form-item
          >
          <el-form-item label="店铺状态：">
            {{ dictMap["shop_status"][detailForm.shopStatus] }}
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer">
        <el-button type="primary" size="small" @click="dialogVisible = false"
          >确 定</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      :close-on-click-modal="false"
      title="关联账号"
      :visible.sync="relaSubAccount.dialogVisible"
      width="40%"
    >
      <el-table
        ref="accountList"
        v-loading="relaSubAccount.loading"
        :data="relaSubAccount.tableData"
        border
        @selection-change="handleSubAccountSelectionChange"
      >
        <el-table-column
          type="selection"
          width="55"
          align="center"
        ></el-table-column>
        <el-table-column label="账号" prop="userName"></el-table-column>
        <el-table-column label="手机号" prop="phoneNumber"></el-table-column>
        <el-table-column label="姓名" prop="nickName"></el-table-column>
      </el-table>

      <div slot="footer">
        <el-button size="small" @click="relaSubAccount.dialogVisible = false"
          >取消</el-button
        >
        <el-button type="primary" size="small" @click="addSubAccount"
          >保存</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      :close-on-click-modal="false"
      :title="editDialog.title"
      :visible.sync="editDialog.dialogVisible"
      width="36%"
    >
      <el-form
        :model="editDialog.shopForm"
        :rules="editDialog.rules"
        ref="ruleForm"
        label-width="140px"
      >
        <el-form-item label="店铺平台：">
          {{ dictMap["plat_no"][platNo] }}
        </el-form-item>
        <el-form-item label="店铺名称：" prop="shopName">
          <el-input
            size="small"
            v-model="editDialog.shopForm.shopName"
          ></el-input>
        </el-form-item>
         <el-form-item label="店铺类型：" prop="isMainland">
          <el-radio-group v-model="editDialog.shopForm.isMainland">
             <el-radio label="02">
               本土店</el-radio
              >
              <el-radio v-if="false" label="01">
               跨境店</el-radio
              >
          </el-radio-group>
        </el-form-item>
        <el-form-item label="自动同步订单：" prop="isSync">
          <el-radio-group v-model="editDialog.shopForm.isSync">
            <template v-for="(value, key) in dictData['yes_or_no']">
              <el-radio :label="value.value" :key="key">
                {{ value.label }}</el-radio
              >
            </template>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <div
          v-if="!editDialog.shopForm.shopId"
          style="float:left;color:red;font-size:12px;line-height:30px;"
        >
          点击“授权”后，将为你打开Shopee页面，请先登录Shopee账号
        </div>
        <el-button size="small" @click="editDialog.dialogVisible = false"
          >取消</el-button
        >
        <el-button type="primary" size="small" @click="saveShop">
          {{ editDialog.shopForm.shopId ? "保存" : "授权" }}</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import Breadcrumb from "@/components/common/Breadcrumb"
import {
  getShopData,
  addSubAccount,
  addShop,
  updateShop,
  giveShopAuth,
  getAuthorizationUrlShopee,
} from "@/api/system/shopManage"
import { listSubAccount } from "@/api/system/user"

export default {
  name: "shopee",
  components: { Breadcrumb },
  data() {
    return {
      allCountries: {},
      countries: [],
      queryParams: {
        shopStatus: "",
        authStatus: "",
        shopName: "",
        beginTime: "",
        endTime: "",
        time: "",
        pageSize: 30,
        pageNum: 1,
        platNo: "11",
      },
      platNo: "11",
      detailForm: {},
      dialogVisible: false,
      total: 0,
      tableData: [],
      relaSubAccount: {
        dialogVisible: false,
        shopId: "",
        total: 0,
        tableData: [],
        queryParams: {
          pageSize: 30,
          pageNum: 1,
        },
        multipleSelection: [],
      },
      editDialog: {
        title: "",
        dialogVisible: false,
        shopForm: {
          isSync: "1",
          shopName: "",
          isMainland: "02"
        },
        rules: {
          shopName: [
            { required: true, message: "请输入店铺名称", trigger: "blur" },
          ],
          amazonSite: [
            { required: true, message: "请选择开户站", trigger: "blur" },
          ],
        },
      },
      authDialog: {
        dialogVisible: false,
        shopForm: {},
        rules: {
          shopName: [
            { required: true, message: "请输入店铺名称", trigger: "blur" },
          ],
          amazonSite: [
            { required: true, message: "请选择开户站", trigger: "blur" },
          ],
          amazonAccount: [
            { required: true, message: "请输入Amazon账号", trigger: "blur" },
          ],
          merchantId: [
            { required: true, message: "请输入卖家编号", trigger: "blur" },
          ],
          token: [
            { required: true, message: "请输入MWS授权令牌", trigger: "blur" },
          ],
          isSync: [
            {
              required: true,
              message: "请选择是否自动同步订单",
              trigger: "change",
            },
          ],
        },
      },
      operNo: "",
      routeUrl: "",
    }
  },
  computed: {
    ...mapGetters(["dictData", "dictMap"]),
    routeName() {
      return this.$route.path
    },
  },
  watch: {
    routeName() {
      this.loadData()
    },
  },
  mounted() {
    let code = this.$route.query.code
    let error = this.$route.query.error
    let msg = this.$route.query.msg
    this.loadData()
    this.loadAllCountry()
    if (code == "0") {
      this.msgError("shopee店铺绑定失败")
      return
    }

    if (code == "1") {
      this.msgSuccess("shopee店铺绑定成功")
      return
    }

    if(error == "1" && msg){
      this.msgError(msg)
      return
    }
  },
  methods: {
    loadAllCountry() {
      let that = this
      $.ajax({
        url: process.env.BASE_URL + "country.json",
        method: "get",
        success: function(res) {
          let all = []
          // res.map.forEach((value,key) =>{
          //     all.concat(value);
          // });
          for (let key in res.map) {
            all = all.concat(res.map[key])
          }
          res.map["0"] = all
          that.allCountries = JSON.parse(JSON.stringify(res))
          that.countries = that.allCountries.map["0"]
        },
      })
    },

    /* 获取列表数据 */
    loadData() {
      this.startLoading()

      if (this.queryParams.time) {
        this.queryParams.beginTime = this.queryParams.time[0]
        this.queryParams.endTime = this.queryParams.time[1]
      } else {
        this.queryParams.beginTime = undefined
        this.queryParams.endTime = undefined
      }
      let params = Object.assign({}, this.queryParams)
      delete params["time"]

      //根据路由判断加载页面
      params.platNo = "11"

      this.platNo = params.platNo
      getShopData(params)
        .then((response) => {
          this.tableData = response.rows
          this.total = response.total
          this.endLoading()
        })
        .catch(() => {
          this.endLoading()
        })
    },
    resetForm() {
      this.$refs["form"].resetFields()
    },
    handleShowDetail(row) {
      this.dialogVisible = true
      this.detailForm = row
    },
    handleShowRelaSubAccount(row) {
      this.relaSubAccount.dialogVisible = true
      this.relaSubAccount.shopId = row.shopId
      this.operNo = row.operNo
      this.loadAccountData(row)
    },
    async handleAuth(row) {
      let result = await getAuthorizationUrlShopee({ shopId: row.shopId })
      window.open(result.data, "_blank")
    },
    loadAccountData(row) {
      this.startLoading()
      let params = {}
      delete params["time"]
      listSubAccount(params)
        .then((response) => {
          this.relaSubAccount.tableData = response.rows
          this.relaSubAccount.total = response.total
          this.endLoading()

          this.$nextTick(() => {
            let operNoArray = row.operNos.split(",")
            for (let record of response.rows) {
              if (operNoArray.includes(record.userName)) {
                this.$refs.accountList.toggleRowSelection(record, true)
              }
            }
          })
        })
        .catch(() => {
          this.endLoading()
        })
    },
    /*表选中事件 */
    handleSubAccountSelectionChange(val) {
      this.relaSubAccount.multipleSelection = val
    },
    /* 获取子账号列表数据 */
    addSubAccount() {
      let operNo = []
      if (this.relaSubAccount.multipleSelection.length == 0) {
        this.$message.warning("请选择子账户！")
        return
      } else {
        this.relaSubAccount.multipleSelection.forEach((row) => {
          operNo.push(row.userName)
        })
      }
      // if (!operNo.includes(this.operNo)) {
      //   this.$message.warning("自己的自助店铺不能取消关联")
      //   return
      // }
      let params = {
        shopId: this.relaSubAccount.shopId,
        operNo: operNo.join(","),
      }
      addSubAccount(params).then((response) => {
        if (response.code == "200") {
          this.$message.success("关联成功！")
          this.relaSubAccount.dialogVisible = false

          this.loadData()
        } else {
          this.$message.error("关联失败")
        }
      })
    },
    async handleShowEditShop(row) {
      if (row.shopId) {
        this.editDialog.title = "编辑店铺"
        this.editDialog.shopForm = {
          shopId: row.shopId,
          shopName: row.shopName,
          platNo: this.platNo,
          isSync: row.isSync,
          isMainland: row.isMainland
        }
      } else {
        this.editDialog.title = "新增店铺"
        this.editDialog.shopForm = {
          shopName: "",
          platNo: "11",
          isSync: "1",
          isMainland: "02"
        }
      }

      this.editDialog.dialogVisible = true
    },
    /**保存店铺信息 */
    saveShop() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          if (this.editDialog.shopForm.shopId) {
            updateShop(this.editDialog.shopForm).then((response) => {
              if (response.code == "200") {
                this.$message.success("修改成功！")
                this.editDialog.dialogVisible = false
                this.loadData()
              } else {
                this.$message.error("修改失败")
              }
            })
          } else {
            addShop(this.editDialog.shopForm).then((response) => {
              if (response.code == "200") {
                this.$message.success("新增成功！")
                this.editDialog.dialogVisible = false
                window.open(response.msg, "_blank")
                this.loadData()
              } else {
                this.$message.error("新增失败")
              }
            }).catch((error) => {
                if (error.toString().indexOf("最大限制数量") > -1) {
                  this.$confirm(
                    "已有店铺数量已超最大限制数量，是否购买会员套餐",
                    "提示",
                    {
                      confirmButtonText: "确定",
                      cancelButtonText: "取消",
                      type: "warning",
                    }
                  ).then(() => {
                    this.$router.push({
                      path: "/system/account/purchaseMember",
                    })
                  })
                }
              })
          }
        } else {
          console.log("error submit!!")
          return false
        }
      })
    },
    /**显示授权页面 */
    handleShowAuthShop(row) {
      this.authDialog.dialogVisible = true
      this.authDialog.shopForm = Object.assign({}, row)
    },
    /**授权店铺信息 */
    saveAuthShop() {
      this.$refs["ruleAuthForm"].validate((valid) => {
        if (valid) {
          this.startLoading()
          giveShopAuth(this.authDialog.shopForm).then((response) => {
            this.endLoading()
            if (response.code == "200") {
              this.$message.success("授权成功！")
              this.authDialog.dialogVisible = false
              this.loadData()
            } else {
              this.$message.error("授权失败")
            }
          })
        } else {
          console.log("error submit!!")
          return false
        }
      })
    },
    /**保存店铺信息 */
    giveShopAuth(shopId, shopStatus) {
      const params = {
        shopId: shopId,
        shopStatus: shopStatus,
      }
      let imfo = "启用"
      if (shopStatus != "01") {
        imfo = "删除"
      }
      this.$confirm(
        `<span style="color:red;">删除店铺后，信息将彻底删除，且不可恢复？</span>`,
        "提示",
        {
          confirmButtonText: "确定删除",
          cancelButtonText: "再想想",
          dangerouslyUseHTMLString: true,
        }
      ).then((type) => {
        if (type == "confirm") {
          updateShop(params).then((response) => {
            if (response.code == "200") {
              this.$message.success(imfo + "成功！")
              this.authDialog.dialogVisible = false
              this.loadData()
            } else {
              this.$message.error(imfo + "失败！")
            }
          })
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.btn-bar-right {
  text-align: right;
}
</style>
